import GoBack from 'components/wise-components/GoBack';
import NewContactForm from 'components/wise-components/NewContactForm';
import React from 'react';

function MyselfContact() {
  return (
    <>
      <GoBack text="Enter your account details" />

      <div className="mt-4">
        <p className="fw-bold fs-1 text-900">Bank details</p>
      </div>
      <NewContactForm />
    </>
  );
}

export default MyselfContact;
